import React from 'react';
import CreativeCard from './CreativeCard';

interface TopCreative {
  id: string;
  name: string;
  previewUrl: string;
  isVideo: boolean;
  title: string;
  description: string;
  metrics: {
    leads: string;
    clicks: string;
    costPerLead: string;
    costPerClick: string;
    hookRate: string;
    holdRate: string;
    impressions: string;
    spend: string;
  };
  creativeType: string;
}

interface TopCreativesProps {
  topCreatives: TopCreative[];
}

const TopCreatives: React.FC<TopCreativesProps> = ({ topCreatives = [] }) => {
  console.log(topCreatives , " rtyuistyrftuidzfdjsuyigfuyi")
  if (!topCreatives || topCreatives.length === 0) {
    return (
      <div className="space-y-6 mt-8">
        <div className="flex justify-between items-center">
          <div>
            <p className="lg:text-[28px] text-[20px] font-semibold text-black font-inter">
              Top creatives
            </p>
            <p className="text-base font-inter font-normal text-[#4A4D4F]">
              No creative data available
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Format the creatives data to match the CreativeCard props
  const formattedCreatives = topCreatives.map(creative => ({
    id: creative.id,
    imageSrc: creative.previewUrl,
    isVideo: creative.isVideo,
    title: creative.title || creative.name,
    description: creative.description,
    stats: [
      { label: 'Amount of leads', value: creative.metrics.leads },
      { label: 'Amount of clicks', value: creative.metrics.clicks },
      { label: 'Cost per lead', value: creative.metrics.costPerLead },
      { label: 'Cost per click', value: creative.metrics.costPerClick },
      { label: 'Hook rate', value: creative.metrics.hookRate },
      { label: 'Hold rate', value: creative.metrics.holdRate },
    ],
    detailsLink: `#creative-${creative.id}`,
    metrics: creative.metrics,
    creativeType: creative.creativeType
  }));

  return (
    <div className="space-y-6 mt-8">
      <div className="flex justify-between items-center">
        <div>
          <p className="lg:text-[28px] text-[20px] font-semibold text-black font-inter">
            Top creatives
          </p>
          <p className="text-base font-inter font-normal text-[#4A4D4F] lg:block hidden">
          Your Top Creatives: Discover What’s Capturing Attention and Driving Results.
          </p>
        </div>
        <button className="bg-black text-white px-4 py-2 rounded-lg text-sm font-medium">
          See all creatives
        </button>
      </div>

      <p className="text-base font-inter font-normal text-[#4A4D4F] lg:hidden block">
      Your Top Creatives: Discover What’s Capturing Attention and Driving Results.
      </p>

      <div className="lg:grid lg:grid-cols-2 xl:grid-cols-2 gap-6 md:grid-cols-2 grid-cols-1 md:overflow-x-visible overflow-x-auto hide-scrollbar">
        {formattedCreatives.map((creative, index) => (
          <CreativeCard
            key={creative.id}
            imageSrc={creative.imageSrc}
            stats={creative.stats}
            detailsLink={creative.detailsLink}
            isVideo={creative.isVideo}
          />
        ))}
      </div>
    </div>
  );
};

export default TopCreatives;